import { mapState } from 'vuex';
import { FILTERS } from '@/store/types/namespaces';

/*
 * Small utility mixins that allow easy converting between different data types, that will be used
 * all over the application
 */

// FIXME: it is very surprising that a mixin will throw because a component
// doesn't have certain traits.
const noPropsMessage = 'The component useListableProperties to convert to a property';
const noFiltersMessage = 'The component must have filters getter defined to convert to a filter';
const noActionsMessage = 'The component must have actions getter defined to convert to an action';

export function convertPropertyNameToProperty(propertyName, self) {
  const scope = self || this;

  // Catch the case of passing in a full object
  if (typeof propertyName === 'object') {
    return propertyName;
  }

  if (scope.listableProperties === undefined) {
    throw new Error(noPropsMessage);
  }

  let returnedProperty = null;
  scope.listableProperties.forEach((p) => {
    if (p.name === propertyName) {
      returnedProperty = p;
    }
  });
  return returnedProperty;
}

export function convertFilterIdToFilter(filterId, self) {
  const scope = self || this;

  // Catch the case of passing in a full object
  if (typeof filterId === 'object') {
    return filterId;
  }

  let parsedId = filterId;
  if (filterId.indexOf('/savedSearches/') > -1) {
    parsedId = filterId.replace('/savedSearches/', '');
  }

  if (scope.filters === undefined) {
    throw new Error(noFiltersMessage);
  }

  let returnedFilter = null;
  const key = filterId.startsWith('fil_') ? 'nodeId' : 'id';
  scope.filters.forEach((f) => {
    if (f[key] === parsedId) {
      returnedFilter = f;
    }
  });
  return returnedFilter;
}

export function convertActionIdToAction(actionId, self) {
  const scope = self || this;

  if (scope.actions === undefined) {
    throw new Error(noActionsMessage);
  }

  let returnedAction = null;
  scope.actions.forEach((a) => {
    if (a.$id === actionId) {
      returnedAction = a;
    }
  });
  return returnedAction;
}

export default {
  computed: {
    ...mapState(FILTERS, ['filters']),
  },
  methods: {
    // Properties
    convertPropertyNameToProperty,

    // Filters
    convertFilterIdToFilter,

    // Actions (notifications)
    convertActionIdToAction,
  },
};
